import { Alert, Link, VFlow } from 'bold-ui'
import { useAcompanhamentoPreNatalQuery } from 'graphql/hooks.generated'
import { useEffect, useState } from 'react'
import { useHistory, useRouteMatch } from 'react-router'

import { usePeriodoGestacional } from '../../soap/aside/pre-natal/hooks/usePeriodoGestacional'
import { getDumAtual } from '../../soap/aside/pre-natal/util/util-acompanhamentoPreNatal'
import { isGestacaoExcedida } from '../../soap/pre-natal/util-preNatal'
import { ExternalPaths } from '../model-acompanhamentos'
import { AcompanhamentoPreNatalTabs, INFO_GESTACAO_URL } from './AcompanhamentoPreNatalTabs'
import { AntecedentesObstetricosCard } from './components/AntecedentesObstetricosCard'
import { GestacaoSemDesfechoModal } from './components/GestacaoSemDesfechoModal'

interface AcompanhamentoPreNatalContentProps {
  prontuarioId: ID
  atendimentoId: ID
  cidadaoId: ID
  dataReferencia: Instant
  externalPaths: ExternalPaths
  isVisualizacaoProntuario: boolean
  isEscutaInicial: boolean
}

export function AcompanhamentoPreNatalContent(props: AcompanhamentoPreNatalContentProps) {
  const {
    prontuarioId,
    atendimentoId,
    cidadaoId,
    dataReferencia,
    externalPaths,
    isVisualizacaoProntuario,
    isEscutaInicial,
  } = props
  const match = useRouteMatch()
  const history = useHistory()

  const [isModalOpen, setIsModalOpen] = useState(false)

  const {
    data: { atendimentosProfUltimaGestacao },
    loading: loadingAtendimentos,
  } = useAcompanhamentoPreNatalQuery({
    variables: {
      input: prontuarioId,
    },
    fetchPolicy: 'cache-and-network',
    skip: !prontuarioId,
  })

  const dum = getDumAtual(atendimentosProfUltimaGestacao)

  const { dataInicioGestacao } = usePeriodoGestacional({
    prontuarioId: prontuarioId,
    dum,
    dataAtendimento: dataReferencia,
    atendimentosProfUltimaGestacao,
  })

  const isGestacaoUltrapassada = dataInicioGestacao && isGestacaoExcedida(dataInicioGestacao, dataReferencia)

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  useEffect(() => {
    match.url.endsWith(`pre-natal`) && history.location.pathname.replace(match.url, `${match.url}/${INFO_GESTACAO_URL}`)
  })

  return (
    <VFlow>
      {isGestacaoUltrapassada && (
        <>
          <Alert type='warning'>
            Esta gestação ainda não teve desfecho no sistema.{' '}
            <Link onClick={handleOpenModal}>Ajuda sobre o desfecho da gestação</Link>
          </Alert>
          <GestacaoSemDesfechoModal
            onClose={() => setIsModalOpen(false)}
            isModalOpen={isModalOpen}
            basePath={externalPaths.basePath}
          />
        </>
      )}
      <AntecedentesObstetricosCard prontuarioId={prontuarioId} />
      <AcompanhamentoPreNatalTabs
        cidadaoId={cidadaoId}
        prontuarioId={prontuarioId}
        atendimentoId={atendimentoId}
        dataReferencia={dataReferencia}
        externalPaths={externalPaths}
        isVisualizacaoProntuario={isVisualizacaoProntuario}
        isEscutaInicial={isEscutaInicial}
        atendimentosProfUltimaGestacao={atendimentosProfUltimaGestacao}
        loadingAtendimentos={loadingAtendimentos}
        dum={dum}
      />
    </VFlow>
  )
}
